import { observer } from "mobx-react-lite";

import { Persona, PersonaSize, Stack } from "@bps/fluent-ui";
import { Contact } from "@stores/practice/models/Contact.ts";

interface ContactPickerFieldContentProps {
  contact: Contact;
}

export const ContactPickerFieldContent = observer(
  ({ contact }: ContactPickerFieldContentProps) => (
    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
      <Persona
        id={contact.id}
        size={PersonaSize.size24}
        imageInitials={contact.initials}
        styles={{
          root: {
            flex: 0,
            alignSelf: "center",
            ".ms-Persona-initials span": {
              color: "white",
              fontSize: 10
            }
          }
        }}
      />

      <span>{contact.reversedName}</span>
    </Stack>
  )
);
